import React, { Component } from "react";
import withRouter from "../../../Utils/withRouter";
import { NoRecords } from "../../../Components/Shimmer";
import { formatDateWithTime } from "../../../Constants/constants";


class SalaryDetailsView extends Component {
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      minimumWages: "",
      stipend: "",
      monthlyBonus: "",
      washingAllowance: "",
      basic: "",
      HRA: "",
      conveyance: "",
      medicalAllowance: "",
      otherAllowance: "",
      gross: "",
      errors: {},
      data: [],
    };
  }

  componentDidMount() {
    this.setState(
      { loadingList: false, data: this.props.data },
      (prevState) => {}
    );
  }

  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();

    // Validate the form
    const errors = this.validateForm();

    if (Object.keys(errors).length === 0) {
      // Form is valid, perform further actions with the form data here
      // Example: Log the form data
    } else {
      // Form is not valid, update state with errors
      this.setState({ errors });
    }
  };

  // Custom validation function with regex
  validateForm = () => {
    const errors = {};

    // Validate individual fields
    if (!this.state.bloodGroup) {
      errors.bloodGroup = "Blood Group is required";
    }

    if (!this.state.employeeCategory) {
      errors.employeeCategory = "Employee Category is required";
    }

    if (!this.state.employeeType) {
      errors.employeeType = "Employee Type is required";
    }

    if (!this.state.permanentAddress) {
      errors.permanentAddress = "Permanent Address is required";
    }

    // Regex for valid 6-digit pin code
    const pinCodeRegex = /^[0-9]{6}$/;

    if (!this.state.pinCode) {
      errors.pinCode = "Pin Code is required";
    } else if (!pinCodeRegex.test(this.state.pinCode)) {
      errors.pinCode = "Invalid Pin Code. Must be a 6-digit number.";
    }

    // Add more validation rules as needed

    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
      <div >
        <div className="container mt-2">
          <div className="row g-3">
            <div>
              <h5>Salary Details</h5>
            </div>
            <div className=" mt-0">
              <h6>{this.state.data[0]?.created_date
                              ? formatDateWithTime(this.state.data[0]?.created_date)
                              : ""}</h6>
              <table
                className="table table-nowrap table-sm "
                style={{ marginBottom: "50px" }}
              >
                <thead className="table-light ">
                  <tr>
                    <th style={{width:"10%"}} scope="col">Sr.No.</th>
                    {/* <th scope="col">Date</th> */}
                    <th style={{width:"70%"}} scope="col">Allowance Type</th>
                    <th style={{width:"20%"}} scope="col">Amount</th>
                    {/* <th scope='col'>Action</th> */}
                  </tr>
                </thead>
                {this.state.data?.length === 0 ? (
                  <tbody>
                    <tr>
                      <td colSpan={12}>
                        <NoRecords />
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {this.state.data?.map((allowance, index) => {
                      return index !== this.state.data?.length-1? (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{allowance?.company_salary_head}</td>
                          <td>{allowance?.company_salary_head_value}</td>
                        </tr>
                      ):null;
                    })}
                  </tbody>
                )}
                {/* <tfoot className="table-light">
                  <tr>
                    <th scope="rowgroup" colSpan="1"></th>
                    <th scope="rowgroup" colSpan="1"></th>
                    <th scope="rowgroup" colSpan="1">
                      CTC
                    </th>
                    <th scope="rowgroup" colSpan="1">
                      {this.state.data[this.state.data?.length-1]?.ctc}
                    </th>
                    <th scope="rowgroup" colSpan="1"></th>
                  </tr>
                </tfoot> */}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SalaryDetailsView);
